import { render, staticRenderFns } from "./LavorazioneSummary.vue?vue&type=template&id=31734d7a"
import script from "./LavorazioneSummary.vue?vue&type=script&lang=js"
export * from "./LavorazioneSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports